import React, { PropTypes } from 'react';
import Helmet from "react-helmet";




    var grafik = {
      "trends": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&competitionId=pw_usa&language=sv"
        , "trendslinjal": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&standaloneDetail=status&competitionId=pw_usa&language=sv"
        , "trendskarta": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusPoll&standaloneDetail=map&competitionId=pw_usa&language=sv"
        , "latest": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&competitionId=pw_usa&language=sv"
        , "latestlinjal": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&standaloneDetail=status&competitionId=pw_usa&language=sv"
        , "latestkarta": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=statusLive&standaloneDetail=map&competitionId=pw_usa&language=sv"
        , "kongress": "http://uswahl-dpa-electionslive.s3.amazonaws.com/svt/html/indexSA.html?standalone=congress&competitionId=pw_usa&language=sv"

    };



class Pym extends React.Component {



  componentDidMount() {

    const {value} = this.props;


    var checkPym = setInterval(function(){
      if (window.pym != undefined){
        clearInterval(checkPym);
        new window.pym.Parent(value, grafik[value]);
      }

    },300);

  }
  render()  {
    const {value} = this.props;
    const style = require('./usagrafik.scss');


    return (
      <div>


      <Helmet
      script={[{"src": "http://uswahl-dpa-electionslive.s3.amazonaws.com/pw_usa/assets/js/pym.min.js", "type": "text/javascript"}]}
      />
      <div id={value} className={style.wrapper}></div>

      </div>


    );


  }
}


Pym.propTypes = {
  value: PropTypes.string
};

export default Pym;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Usagrafik/usagrafik.js
 **/